import {createReducer, on} from '@ngrx/store';
import {clearDeleteManyDvrState, deleteManyDvr, deleteManyDvrFailure, deleteManyDvrSuccess} from './dvr.delete-many.actions';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';


export interface State {
  record: DvrRecord[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyDvrReducer = createReducer(
  initialState,

  on(deleteManyDvr, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyDvrSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyDvrFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyDvrState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

